import React from "react";
import landData from "./data/utahLandData.json";

import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import OwnershipPie from "../components/OwnershipPie";
import FederalAgencyChart from "../components/FederalAgencyChart";
import ParksChart from "../components/ParksChart";

const UtahLand = () => {
  const parseNumber = (value) => {
    if (value == null) return 0;
    const cleaned = String(value).replace(/,/g, "");
    const n = Number(cleaned);
    return Number.isNaN(n) ? 0 : n;
  };

  const ownership = landData.ownership_distribution.map((item) => ({
    ...item,
    acres: parseNumber(item.acres),
  }));

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white text-slate-900">
      <LandingSection
        data={{
          imageName: "utahfaqbg.jpg",
          title: "Utah Land Ownership",
          visible: "",
          overlay: "linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3))",
        }}
      />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Utah Land Ownership & Distribution
          </h1>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Utah contains approximately 54.3 million acres of land. The majority of land in Utah is federally managed, followed by private, state, and tribal lands.
          </p>
        </div>

        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
          {ownership.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-[0_16px_40px_rgba(15,23,42,0.08)] border border-slate-100 p-6 text-center hover:shadow-[0_20px_60px_rgba(15,23,42,0.12)] transition-shadow"
            >
              <h3 className="text-lg font-semibold text-blue-800 mb-2">
                {item.type} Land
              </h3>
              <p className="text-4xl font-bold text-blue-600 mb-2">
                {item.percent}%
              </p>
              <p className="text-sm text-slate-500">
                {item.acres > 0
                  ? `${(item.acres / 1000000).toFixed(1)}M acres`
                  : "N/A"}
              </p>
            </div>
          ))}
        </section>

        <section className="mb-14">
          <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
            <h2 className="text-2xl font-bold text-blue-900 mb-6">Land Ownership by Type</h2>
            <OwnershipPie data={ownership} />
          </div>
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-14">
          <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
            <h2 className="text-2xl font-bold text-blue-900 mb-6">
              Federal Agencies Managing Utah Land
            </h2>
            <FederalAgencyChart agencies={landData.federal_agencies} />
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
            <h2 className="text-2xl font-bold text-blue-900 mb-6">
              National Parks & Protected Areas
            </h2>
            <ParksChart parks={landData.national_parks} />
          </div>
        </section>

        <section className="mt-20">
          <h2 className="text-2xl font-bold mb-4">Sources</h2>
          <ul className="list-disc pl-6 text-blue-600 space-y-2">
            {landData.sources.map((src, i) => (
              <li key={i}>
                <a href={src} target="_blank" rel="noreferrer" className="hover:underline">
                  {src}
                </a>
              </li>
            ))}
          </ul>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default UtahLand;